import axios from "axios";

const API_BASE =
    process.env.REACT_APP_API_URL || "https://api.shrianshnexus.in";

axios.defaults.withCredentials = true;

function getGenerationEngine() {
    try {
        const params = new URLSearchParams(window.location.search);
        const engine = (params.get("engine") || "").toLowerCase();

        if (engine === "v2") return "v2";
        if (engine === "v1") return "v1";

        return process.env.REACT_APP_GENERATION_ENGINE || "v1";
    } catch {
        return process.env.REACT_APP_GENERATION_ENGINE || "v1";
    }
}

function isV2() {
    return getGenerationEngine() === "v2";
}

function normalizeV2PreviewResponse(data) {
    return {
        ...data,
        previewSessionId:
            data?.previewSessionId ||
            data?.PreviewSessionId ||
            data?.id ||
            data?.Id ||
            "",
        status: data?.status || data?.Status || "",
        isV2Flow: true
    };
}

export async function createAndQueueProject(payload) {
    const response = await axios.post(
        `${API_BASE}/api/website/generate`,
        payload,
        { withCredentials: true }
    );

    return response.data;
}

export async function createAndQueuePreviewSession(payload) {
    if (isV2()) {
        const response = await axios.post(
            `${API_BASE}/api/website-v2/preview-generate`,
            payload,
            { withCredentials: true }
        );

        return normalizeV2PreviewResponse(response.data);
    }

    const response = await axios.post(
        `${API_BASE}/api/website/preview-generate`,
        payload,
        { withCredentials: true }
    );

    return response.data;
}

export async function getPreview(projectId, variantKey = null) {
    const query = variantKey ? `?variantKey=${encodeURIComponent(variantKey)}` : "";

    const response = await axios.get(
        `${API_BASE}/api/website/${projectId}/preview${query}`,
        { withCredentials: true }
    );

    return response.data;
}

export async function getPreviewSession(previewSessionId, variantKey = null) {
    if (isV2()) {
        const response = await axios.get(
            `${API_BASE}/api/website-v2/preview-session/${previewSessionId}`,
            { withCredentials: true }
        );

        return {
            ...response.data,
            previewSessionId,
            isV2Flow: true,
            previewUrl: `${API_BASE}/api/website-v2/preview-session/${previewSessionId}/document`
        };
    }

    const query = variantKey ? `?variantKey=${encodeURIComponent(variantKey)}` : "";

    const response = await axios.get(
        `${API_BASE}/api/website/preview-session/${previewSessionId}${query}`,
        { withCredentials: true }
    );

    return response.data;
}

export async function getPreviewSessionStatus(previewSessionId) {
    if (isV2()) {
        const response = await axios.get(
            `${API_BASE}/api/website-v2/preview-session/${previewSessionId}`,
            { withCredentials: true }
        );

        return {
            status: response.data?.status || response.data?.Status || "Generated",
            isReady: true,
            isV2Flow: true,
            previewSessionId
        };
    }

    const response = await axios.get(
        `${API_BASE}/api/website/preview-session/${previewSessionId}/status`,
        { withCredentials: true }
    );

    return response.data;
}

export function getPreviewSessionDocumentUrl(previewSessionId) {
    if (isV2()) {
        return `${API_BASE}/api/website-v2/preview-session/${previewSessionId}/document`;
    }

    return `${API_BASE}/api/website/preview-session/${previewSessionId}/document`;
}

export async function claimPreviewSession(previewSessionId) {
    if (isV2()) {
        const response = await axios.post(
            `${API_BASE}/api/website-v2/preview-session/${previewSessionId}/claim`,
            {},
            { withCredentials: true }
        );

        return response.data;
    }

    const response = await axios.post(
        `${API_BASE}/api/website/preview-session/${previewSessionId}/claim`,
        {},
        { withCredentials: true }
    );

    return response.data;
}

export async function publishProject(projectId) {
    const response = await axios.post(
        `${API_BASE}/api/website/${projectId}/publish`,
        {},
        { withCredentials: true }
    );

    return response.data;
}

export async function regenerateProject(projectId, payload = {}) {
    const response = await axios.post(
        `${API_BASE}/api/website/${projectId}/regenerate`,
        payload,
        { withCredentials: true }
    );

    return response.data;
}

export async function autofillWebsiteForm(payload) {
    const response = await axios.post(
        `${API_BASE}/api/website/autofill`,
        payload,
        { withCredentials: true }
    );

    return response.data;
}

export async function getThemes() {
    const response = await axios.get(
        `${API_BASE}/api/website/themes`,
        { withCredentials: true }
    );

    return response.data;
}

export function getActiveGenerationEngine() {
    return getGenerationEngine();
}